import { useLayerStale } from "../../hooks/useLayerStale";
import { Layer } from "../../types/layer";

export type ImageryOverlay = { url: string; coordinates: number[][] };

/** One image source per PNG chunk the fine-detail tool saved (the aerial
 *  photo it looked at), draped under the proposed changes so each can be
 *  judged against the other. A fixed number of slots: the map only updates
 *  layers it is handed and never removes missing ones, so a slot with no
 *  chunk carries a blank pixel, switched off. */
export const IMAGERY_SLOTS = 8;

const BLANK_PIXEL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";
const BLANK = { type: "image", url: BLANK_PIXEL, coordinates: [[0, 0], [0.0001, 0], [0.0001, -0.0001], [0, -0.0001]] };

const DataReviewImageryLayers = (idPrefix: string, overlays: ImageryOverlay[], visible: boolean): Layer[] => {
  const staleOf = useLayerStale();
  return Array.from({ length: IMAGERY_SLOTS }, (_, i) => {
    const chunk = overlays[i];
    const id = `${idPrefix}-${i}`;
    const source = chunk ? { type: "image", url: chunk.url, coordinates: chunk.coordinates } : BLANK;
    return {
      id,
      name: "Aerial photo",
      type: "raster",
      source,
      layerStyle: { id, type: "raster", source, paint: { "raster-opacity": 1, "raster-fade-duration": 0 } },
      // A different chunk (a new run, a discarded one) rebuilds the layer.
      styleKey: source.url,
      toolbarButton: null,
      active: visible && !!chunk,
      ...staleOf(id, source.url, source.coordinates),
    };
  });
};

export default DataReviewImageryLayers;
